import React from "react";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import { CREATIVE_NAMES, DISPLAY_SKYBOX_AD_FIELDS } from "./definitions";
import InputTextSection from "./InputTextSection";
import BaseCreativeControls from "./BaseCreativeControls";

const CREATIVE_TYPE = CREATIVE_NAMES.DISPLAY_SKYBOX;

export default function DisplaySkybox({
    displayCreativeUrl,
    collapsedCreaiveUrl,
    mobileCreativeUrl,
    handleChange,
    currentCustomer,
    impressionTag,
    clickTag,
    adServingType
}) {
    return (
        <>
            <BaseCreativeControls
                adServingType={adServingType}
                changeHandler={handleChange}
                clickTag={clickTag}
                creativeType={CREATIVE_TYPE}
                impressionTag={impressionTag}
            >
                <AssetInputOrUploadSection
                    inputValue={displayCreativeUrl}
                    inputLabel="Desktop Banner (1456x180px)"
                    inputName={DISPLAY_SKYBOX_AD_FIELDS.displayCreativeUrl}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
                <AssetInputOrUploadSection
                    inputValue={collapsedCreaiveUrl}
                    inputLabel="Collapsed Banner (525x250px)"
                    inputName={DISPLAY_SKYBOX_AD_FIELDS.collapsedCreaiveUrl}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
                <AssetInputOrUploadSection
                    inputValue={mobileCreativeUrl}
                    inputLabel="Mobile Banner (360x180px or 1:2 ratio)"
                    inputName={DISPLAY_SKYBOX_AD_FIELDS.mobileCreativeUrl}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
            </BaseCreativeControls>
        </>
    );
}